import React from 'react';

const DeleteSVG = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" rx="4" fill="white"/>
      <path fillRule="evenodd" clipRule="evenodd"
            d="M9 3.40039C7.89543 3.40039 7 4.29582 7 5.40039V6.59961H4.2002C3.64791 6.59961 3.2002 7.04732 3.2002 7.59961C3.2002 8.15189 3.64791 8.59961 4.2002 8.59961H4.7998V13C4.7998 14.6569 6.14295 16 7.7998 16H12.3998C14.0567 16 15.3998 14.6569 15.3998 13V8.59961H15.8002C16.3525 8.59961 16.8002 8.15189 16.8002 7.59961C16.8002 7.04732 16.3525 6.59961 15.8002 6.59961H13V5.40039C13 4.29582 12.1046 3.40039 11 3.40039H9ZM11 6.59961V5.40039H9V6.59961H11ZM6.7998 8.59961H13.3998V13C13.3998 13.5523 12.9521 14 12.3998 14H7.7998C7.24752 14 6.7998 13.5523 6.7998 13V8.59961Z"
            fill="#DE4548"/>
    </svg>
  );
};

export default DeleteSVG;
